export default class MinMaxDirective {
    constructor() {
        this.restrict = 'A';
        this.require = 'ngModel';
    }

    link(scope, element, attrs, ngModelCtrl) {
        function fromUser(val) {
            if (val || val === 0) {
                let min = attrs.vmin ? parseInt(attrs.vmin) : 0;
                let max = attrs.vmax ? parseInt(attrs.vmax) : null;

                val = parseInt(val);
                if (val < min) {
                    val = min;
                }

                if (max && val > max) {
                    val = max;
                }

                ngModelCtrl.$setViewValue(val + '');
                ngModelCtrl.$render();

                return val + '';
            }

            ngModelCtrl.$setViewValue(0);
            ngModelCtrl.$render();

            return 0;
        }

        ngModelCtrl.$parsers.push(fromUser);
    }

    static directiveFactory() {
        'ngInject';

        return new MinMaxDirective();
    }
}
